<style media="screen" >

.cd-title-label {
    margin-top: 25px;
    color: rgb(32, 160, 255);
    font-size: 17px;
    margin-bottom: 10px;
}

</style>

<template>
  <div>
      <!-- <el-button @click="goAuthPage">授权网页</el-button> -->
      <div class="basic-margin cd-title-label"><b>数据趋势</b>
        <el-col style="cursor:pointer;padding-left:77px;margin-top:-22px;">
            <el-tooltip placement="top">
                <div slot="content">
                    默认显示最近一周所有渠道页面PV、访问UV的变化趋势。（均为截止昨日数据，每晚0点更新）
                </div>
                <span class="el-icon-information"></span>
            </el-tooltip>
        </el-col>
    </div>
    <el-radio-group v-model="radioValue">
        <el-radio-button label="页面访问量PV"></el-radio-button>
        <el-radio-button label="独立访客UV"></el-radio-button>
        <!-- <el-radio-button label="线索量"></el-radio-button>
        <el-radio-button label="线索收入"></el-radio-button> -->
    </el-radio-group>
    <el-date-picker style="float:right" v-model="dateValue" type="daterange" placeholder="选择日期范围">
    </el-date-picker>
        <div id="clue-data-trend-pic" style="width:100%;height:500px">
        </div>

  </div>

</template>

<script>

import DataMonitorModel from '../../../framework/models/dataMonitorModel'
import SysModel from '../../../framework/models/sysModel'
import DateUtil from '../../../framework/utils/DateUtil'
import echarts from 'echarts'
export default {
  name: 'channel-data-trend-pic',
  data () {
    return {
      centerDialogVisible: false,
      chart: null,
      dataCount: [],
      date: [],
      radioValue: '页面访问量PV',
      dateValue: [],
      series: [],
      nameData: [],
      value: 'https://www.baidu.com'
    }
  },
  props: {

  },

  watch: {
    dateValue (val) {
      this.loadData()
    },
    radioValue () {
      this.loadData()
    }
  },
  created: function () {
    let _this = this
    let date = new Date()
    date.setDate(date.getDate() - 30)
    _this.dateValue.push(date)
    let date2 = new Date()
    date2.setDate(date2.getDate() - 1)
    _this.dateValue.push(date2)
  },
  methods: {
    goAuthPage: function () {
      let _this = this
      _this.centerDialogVisible = true
      let params = {
        channelId: JSON.parse(localStorage.userInfo).id
      }

      let listener = {
        success: function (dataInfo) {
          _this.value = dataInfo.datas
          let height = 600
          let width = 800
          let top = Math.round((window.screen.height - height) / 2)
          let left = Math.round((window.screen.width - width) / 2)
          window.open(dataInfo.datas, '授权', 'height=' + height + ', width=' + width + ', top=' + top + ', left= ' + left + ', toolbar=no, menubar=no, scrollbars=auto, resizable=no, location=yes, status=no')
        }
      }

      SysModel.createLoginPage(_this, params, listener)
    },
    loadData: function () {
      let _this = this
      _this.date = []
      _this.dataCount = []
      _this.series = []
      _this.nameData = []
      let params = _this.buildParams()
      let listener = {
        success: function (dataInfo) {
          _this.dataCount = dataInfo.datas.countResult
          _this.nameData = dataInfo.datas.nameResult
          for (var i = 0, temp = _this.dataCount.length; i < temp; i++) {
            let param = {
              name: _this.nameData[i],
              type: 'line',
              smooth: true,
              data: _this.dataCount[i],
              markPoint: {
                data: [{
                  type: 'max',
                  name: '最大值'
                }, {
                  type: 'min',
                  name: '最小值'
                }]
              },
              markLine: {
                data: [{
                  type: 'average',
                  name: '平均值'
                }]
              }
            }
            _this.series.push(param)
          }
          _this.date = dataInfo.datas.dateResult
          _this.drawPic('clue-data-trend-pic')
        }
      }
      DataMonitorModel.findDataTrend(this, params, listener)
    },
    buildParams: function () {
      let _this = this
      let dataType = null
      switch (this.radioValue) {
        case '页面访问量PV':
          dataType = 1
          break
        case '独立访客UV':
          dataType = 2
          break
        case '线索量':
          dataType = 3
          break
        case '线索收入':
          dataType = 4
          break
        default:
          dataType = 1
          break
      }

      if (!localStorage.userInfo) {
        this.$router.push('/login/channel')
        return
      }

      let params = {
        dataType: dataType,
        channelId: JSON.parse(localStorage.userInfo).id
      }
      let timevalue = this.dateValue
      if (timevalue && timevalue.length && timevalue[0]) {
        let startTime = DateUtil.getDateByUnixTime(timevalue[0].getTime(), '/')
        let endTime = DateUtil.getDateByUnixTime(timevalue[1].getTime(), '/')
        params.startTime = startTime
        params.endTime = endTime
      } else {
        params.startTime = ''
        params.endTime = ''
      }
      return params
    },
    drawPic: function (id) {
      let _this = this
      this.chart = echarts.init(document.getElementById(id))
      let option = {
        grid: {
          top: '13%',
          bottom: '20%',
          borderWidth: 0.1
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: this.nameData
        },
        dataZoom: [{
          type: 'slider',
          start: 0,
          end: 100,
          textStyle: {
            color: '#f39c12'
          },
          handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '60%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 3,
            shadowColor: 'rgba(0, 0, 0, 0.6)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          }
        }],
        toolbox: {
          show: true,
          feature: {
            dataZoom: {},
            dataView: {
              readOnly: false
            },
            magicType: {
              type: ['line', 'bar']
            },
            restore: {},
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          name: '日期',
          nameLocation: 'end',
          axisLabel: {
            rotate: 40
          },
          splitLine: {
            lineStyle: {
              opacity: 0.2
            }
          },
          data: this.date
        },
        yAxis: {
          type: 'value',
          name: '单位',
          nameLocation: 'middle',
          nameGap: '40',
          splitLine: {
            lineStyle: {
              opacity: 0.2
            }
          },
          axisLabel: {
            formatter: '{value}',
            textStyle: {
              fontSize: '13'
            }
          }
        },
        series: this.series
      }
      this.chart.clear()
      this.chart.setOption(option)
    }
  }

}

</script>
